// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Concur_Core_Types.bindWidget);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Concur_Core_Types.monadEffectWidget(Data_Monoid.monoidArray));
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var scrollSectionIntoView = $foreign.jsScrollIntoView;
var scrollIntoViewWidget = function (state) {
    return function (sectionId) {
        return discard(liftEffect($foreign.jsScrollIntoView(sectionId)))(function () {
            return pure(state);
        });
    };
};
export {
    scrollIntoViewWidget,
    scrollSectionIntoView
};
//# sourceMappingURL=index.js.map
